<template>
  <v-container fluid>
    <v-row>
    <div class="iot" style="width:100%">
      <v-col cols="12" class="pt-0 pb-0">
        <div
          class="iot__filters d-flex align-center my-4"
        >
          <v-row>
            <v-col cols="12
              text-center justify-center align-center d-flex
              pt-0 pb-0 pt-md-3 pb-md-3" md="2">
              <!-- v-if="!loading && !empty"s -->
              <span class="mr-4">CSO Trackers [{{ trackerHits.length }}]</span>
            </v-col>
            <v-col cols="12 d-flex justify-center justify-md-start" md="10">
              <div class="iot__filters__select">
                <!-- Add :items="AddAllTrackerOption(trackerHits)" to add All Option -->
                <v-select
                  v-model="device"
                  :items="trackerHits.filter(i => i.text !== 'All')"
                  @change="selectDevice"
                  return-object
                  solo
                  dense
                  hide-details
                  :value="null"
                >
                </v-select>
              </div>
            </v-col>
          </v-row>
        </div>
      </v-col>
      <v-col cols="12">
        <div class="map__holder mb-5">
          <app-map
            :iot="[{ trackers: [selected] }, air]"
            :dest="sites.B"
            :update="update"
            :done="isComplete(steps.slice().pop())"
          />
        </div>
      </v-col>
      <!-- v-if="!loading && !empty" -->
      <v-col cols="12">
        <div class="chart__holder">
          <app-chart :iot="selected" :update="update"/>
        </div>
      </v-col>
      <v-col cols="12" class="text-center">
      <!-- v-if="loading && !empty" -->
      <p class="grey--text text-center py-5" v-if="loading">
        Loading trackers.
      </p>
      </v-col>
      <v-col cols="12" class="text-center">
      <!-- <p class="grey--text text-center py-5" v-if="!loading && empty">
        No trackers found for this shipment.
      </p> -->
      </v-col>
    </div>
  </v-row>
  </v-container>
</template>

<script>
import { values, get } from 'lodash';
import { mapState } from 'vuex';
import locationMixin from '@/mixins/location.mixin';
import { uid, oftype } from '@/utils';

export default {
  name: 'business-scope-iot',
  mixins: [locationMixin],
  data() {
    return {
      loading: true,
      device: '',
      selected: { hits: [] },
      update: uid(),
    };
  },
  // This watcher throws an Error if iot = undefined
  watch: {
    'iot.hits': {
      immediate: true,
      handler() {
        this.device = this.trackerHits[0].value;
        this.selectDevice(this.trackerHits[0]);
        this.selected.hits = this.mostHits;
        this.update = uid();
        this.loading = false;
      },
    },
  },
  computed: {
    ...mapState({
      iotAccess: 'IOTAccess',
      iot: 'Order',
      order: 'Order',
      scope: 'Scope',
    }),
    mostHits() {
      let most = [];

      this.trackerHits.forEach((th) => {
        if (th.hits.length > most.length) most = th.hits;
      });

      return most;
    },
    air() {
      // eslint-disable-next-line
      return this.iot.hits
        ? this.iot.hits.filter(h => h._source.air)
        : [];
    },
    road() {
      // eslint-disable-next-line
      return this.iot.hits
        ? this.iot.hits?.filter(h => h._source.tracker)
        : [];
    },
    trackerHits() {
      const hits = this.road.filter((r) => {
        const hitScope1 = get(r, '_source.tracking_request.scope', '').toLowerCase();
        const hitScope2 = get(r, '_source.trackingRequest.scope', '').toLowerCase();
        const hitScope = hitScope1 || hitScope2;
        const currentScope = this.scope?.name.toLowerCase();

        /**
         * @todo
         * Not sure why it doesn't work anymore for ibm, possible causes:
         * - Change from ibm to ibmma in iot services.
         * - change scope name in webportal services.
         */
        if (currentScope === 'ibm') {
          return hitScope.includes(currentScope);
        }

        return hitScope === currentScope;
      });

      /* eslint-disable */
      return values(hits.reduce((holder, current, i) => {
        const tracker = current._source.tracker;
        // Some documents use tracking_request, and others use trackingRequest.
        const trackingRequest = (
          get(current, '_source.tracking_request.references') ||
          get(current, '_source.trackingRequest.references', [])
        );
        const reference = trackingRequest.find(ref => ref.type === 'CaseNumber')?.ref;
        const identifier = tracker.deviceId + reference;

        if (!holder[identifier]) {
          holder[identifier] = {
            text: `${this.iot.shipment} - ${tracker.deviceId} - ${reference}`,
            value: tracker.deviceId,
            hits: [],
          };
        }
        holder[identifier].hits.push(current);

        return holder;
      }, { })).map(v => v);
      /* eslint-enable */
    },
    empty() {
      return !this.selected.hits.length;
    },
    steps() {
      const orders = get(this.order, 'orders');
      if (orders) {
        return (oftype(orders, 'Array') ? orders : [orders])
          .filter(o => this.$lang.translate(`details.majorSteps.${o.type}`));
      }
      return [];
    },
  },
  methods: {
    isComplete(step) {
      switch (this.scope.system) {
        case 'Zenith':
          return window._.get(step, 'complete') === '1';
        default:
          return window._.get(step, 'dates.actualEnd') !== null;
      }
    },
    AddAllTrackerOption(TrackingHits) {
      const found = TrackingHits.find(item => item.hits.length === this.iot.hits.length);
      if (found === undefined) {
        const NewItemsArray = [
          {
            hits: this.iot.hits,
            text: 'All',
            value: '',
          },
          ...TrackingHits,
        ];
        return NewItemsArray;
      }
      return TrackingHits;
    },
    selectDevice(device) {
      // TODO - this.hits does not exists.
      // if (!device.hits) this.selected.hits = this.hits;
      this.selected.hits = device.hits;
      this.update = uid();
      this.$store.commit('IOT_SELECTION', this.selected.hits);
    },
  },
  mounted() {
    if (!this.iotAccess) {
      this.$router.push({
        name: 'client.business-scope.details',
        params: this.$route.params,
        query: this.$route.query,
      });
    }
  },
};
</script>
